// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ExperimentTwoToneSvg from "@ant-design/icons-svg/es/asn/ExperimentTwoTone";
import AntdIcon from '../components/AntdIcon';

var ExperimentTwoTone = function ExperimentTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ExperimentTwoToneSvg
  }));
};

ExperimentTwoTone.displayName = 'ExperimentTwoTone';
export default React.forwardRef(ExperimentTwoTone);